'use strict';

/**
 *
 * @name: nownessApp
 *
 */

import ComponentsModule from './components/components.module';
import PagesModule from './pages/pages.module';
import ConfigModule from './config/config.module';

import '@iamadamjowett/angular-click-outside/clickoutside.directive';
import duScroll from 'angular-scroll';

import AppConfig from './app.config';
import AppRun from './app.run';
import { stripHtml } from './filters/strip-html.filter'

function deleteSpecCookies() {
  document.cookie = 's_cpm=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = 'Akamai_AnalyticsMetrics_clientId=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  document.cookie = 'BC_CAP_OPTS=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
}

deleteSpecCookies();

// Raven
  // .config('https://83b4884d5bdb46e0a6365db324723b30@sentry.io/139639')
  // .addPlugin(Raven.Plugins.Angular)
  // .install();

const NownessApp = angular.module('nownessApp', [
    // 'ngRaven',
    'ngCookies',
    'ngResource',
    'ngSanitize',
    'ngTouch',
    'ngAnimate',
    'ui.router',
    'pascalprecht.translate',
    'ngStorage',
    'ipCookie',
    'infinite-scroll',
    'oc.lazyLoad',
    'angular-click-outside',
    duScroll,

    ConfigModule,
    ComponentsModule,
    PagesModule
  ])
  .config(AppConfig)
  .run(AppRun)
  .filter('stripHtml', stripHtml);

export default NownessApp.name;



// WEBPACK FOOTER //
// ./app/app.module.js